export enum ModalType {
    CHANGE_FIRM = 'changeFirm',
    CHANGE_ROLE = 'changeRole',
    CONFIRM = 'confirm',
    DELETE_FIRM = 'deleteFirm',
    DELETE_USERS = 'deleteUsers',
    SHARE = 'share',
}

export type ModalParams = { onClose?: () => void } & (
  | { type: ModalType.CHANGE_FIRM; onSuccess?: () => void; userIds: number[] }
  | { type: ModalType.CHANGE_ROLE; onSuccess?: (role: string) => void; userIds: number[] }
  | { type: ModalType.CONFIRM; title: string; message?: string; onSubmit: () => void }
  | { type: ModalType.DELETE_FIRM; firmId: number; onSuccess?: () => void }
  | { type: ModalType.DELETE_USERS; onSuccess?: () => void; userIds: number[] }
  | { type: ModalType.SHARE; videoId?: number }
);
